<template>
  <div>
    <div style="display:flex;align-items: center;justify-content: center;flex-wrap: wrap;">
      <button type="button" :disabled="isLoading" @click="sycn_ns_order" class="Button" style="width:180px">立刻抓取NS待出貨訂單</button>
      <button type="button" :disabled="isLoading" @click.stop="customized_process" class="Button" >產生批號</button>
      <button type="button" :disabled="isLoading" @click.stop="openPopUp" class="Button" >查看所有產票結果</button>
    </div>
     
    <div style="margin: 10px;">
      <b-form-select v-model="payway_selected" :options="payway_options" style="width: 12vw; margin-right: 5px;">
      </b-form-select>
      <b-form-select v-model="freightway_selected" :options="freightway_options" style="width: 12vw; margin-right: 5px;">
      </b-form-select>
      <b-form-select v-model="paperway_selected" :options="paperway_options" style="width: 12vw; margin-right: 5px;">
      </b-form-select>
      <b-form-select v-model="printway_selected" :options="printway_options" style="width: 18vw; margin-right: 5px;">
      </b-form-select>
      <button type="button" :disabled="isLoading" @click="process">確認</button>
      <div v-show="printway_selected==1">
        <b-form-checkbox
          id="chk_force_reprint"
          :disabled="table_or_ticket=='ticket'"
          v-model="force_reprint"
          style="width:25vw;display:inline-block;"
          name="force_reprint"
          value="1"
          unchecked-value="0"
        >
          處理已產票訂單pdf下載
        </b-form-checkbox>
        <b-form-input :disabled="force_reprint=='0'" type="text" style="width:20vw;display:inline-block;" v-model="force_batch_no" placeholder="指定批號" ></b-form-input>
        <label
          style="width:10vw;display:inline-block;"
        >
          分頁筆數
        </label>
        <b-form-input type="number"
          style="width:10vw;display:inline-block;"
          :disabled="table_or_ticket=='ticket'"
          v-model="preview_items_per_page"
          placeholder="每分頁顯示訂單數(不填寫預設50)"
        ></b-form-input>
        <b-button
          class="ml-3"
          v-show="table_or_ticket=='ticket'"
          @click="table_or_ticket='table';ableToPrint=false;selected=[];uncheck_all();"
        >
          回列表
        </b-button>
      </div>
    </div>    
    <button type="button" class="mb-2" @click="print" v-if="ableToPrint == true">列印票券/產生PDF檔(二擇一)
    </button>
    <div id="prt_area" v-if="table_or_ticket == 'ticket'">
       <!--order_item => 每筆訂單 -->
      <div class="order" :style="order_index==0?'margin-top:-8px;':''" v-for="(order_item, order_index) in orders" :key="order_index">
        <div class="paper" style="page-break-after: always;position: relative; height: 324mm; width:232mm; display: block; font-family: 'cwTeXKai','Noto Serif TC','Noto Sans SC', serif ;font-weight: 300; font-size:12px;" v-for="(paper, index) in order_item.papers" :key="index">
          <div>
              <!-- 第一張票位置 只有一張的時候-->
              <div v-if="paper.page_tickets.length == 1">

                  <div class="total_no" style="position: absolute;top: 3.2em; left: 11.7em; color:#9b9e96;">__________</div>
                  <div class="order_no" style="position: absolute;top: 3.2em; left: 33.5em; color:#9b9e96;">__________</div>
                  <div class="prod_name" style="position: absolute;top: 5.1em; left: 11.7em; color:#9b9e96;">__________</div>
                  <div class="prodcut_remark1" style="position: absolute;top: 7em; left: 11.7em; color:#9b9e96;">__________</div>
                  <div class="sale_price" style="position: absolute;top: 8.9em; left: 11.7em; color:#9b9e96;">__________</div>
                  <div class="end_date" style="position: absolute;top: 8.9em; left: 27.3em; color:#9b9e96;">__________</div>
                <div class="prodcut_remark2" style="position: absolute;top: 3em; left: 5.5em; text-align: left; line-height:1; font-size:48px;  letter-spacing: 70px; font-weight: 5; color:#9b9e96;">
                <br>
                此張無效
                <br>
                <br>
                <br>
                請勿使用
                </div>
              </div> 
              <div v-if="paper.page_tickets.length == 2">
                <!-- 第一張票位置 有兩張的時候-->
                <div class="ticket_no1" style="    
                    position: absolute;
                    -webkit-transform: rotate(270deg);
                    -moz-transform: rotate(270deg);
                    -o-transform: rotate(270deg);
                    -ms-transform: rotate(270deg);
                    transform: rotate(270deg);
                    width:200px;
                    height:78px;
                    top: 23em;
                    left:-1.3em;">
                  <barcode :value="paper.page_tickets[0].ticket_no" format="CODE128" width="1" height="30" font-size="10" font="Helvetica" fontOptions="normal">
                    Show this if the rendering is failed.
                  </barcode>
                </div>
                <div class="order_no_qrcode" style="position: absolute;width:200px;height:78px;top: 1em; left: 48em;">
                  <barcode :value='order_item.order_id' format="CODE128" width="1" height="20" font-size="10" font="Helvetica" fontOptions="normal" style="font-weight: 600">
                    Show this if the rendering is failed.
                  </barcode>
                </div>
                <!-- 新增NI條碼 -->
                <div class="p1only1" style="position: absolute;width:200px;height:78px;top: 8.5em; left: 48em;">
                  <barcode :value='paper.page_tickets[0].ns_item_id' format="CODE128" width="1" height="20" font-size="10" font="Helvetica" fontOptions="normal" style="font-weight: 600">
                    Show this if the rendering is failed.
                  </barcode>
                </div>
                <div class="total_no" style="position: absolute;top: 3.6em; left: 18.2em;">{{order_item.paper_batch_no}}</div>
                <div class="order_no" style="position: absolute;top: 3.6em; left: 39.6em;">{{ order_item.order_id }} *</div>
                <div class="prod_name" style="position: absolute;top:5.35em; left: 17.8em;">{{paper.page_tickets[0].product_name}}</div>
                <div class="prodcut_remark1" style="position: absolute;top: 7.15em; left: 17.8em;">{{paper.page_tickets[0].prodcut_remark1}}</div>
                <div class="sale_price" style="position: absolute;top: 8.955em; left: 20em;">{{paper.page_tickets[0].sale_price}}</div>
                <div class="end_date" style="position: absolute;top: 9em; left: 35em;">{{paper.page_tickets[0].end_date}}</div>
                <!-- 需限定列印範圍不得超出 -->
                <div class="prodcut_remark2" style="position: absolute;top: 12.7em; left: 13em; text-align: left; line-height:1; width: 75%; height:31mm; overflow-y: hidden" v-html="paper.page_tickets[0].prodcut_remark2">
                </div>
                
                <div class="servicer_name" style="position: absolute;top: 23.8em; left: 20em;">{{paper.page_tickets[0].servicer_name}}</div>
                <div class="servicer_tel" style="position: absolute;top: 25.4em; left: 20em;">{{paper.page_tickets[0].servicer_tel}}</div>
                <div class="servicer_issuer" style="position: absolute;top: 25.4em; left: 40em;"> • 負責人：{{paper.page_tickets[0].servicer_issuer}}</div>
                <div class="servicer_address" style="position: absolute;top: 27em; left: 20em;">{{paper.page_tickets[0].servicer_address}}</div>

                <div class="issuer" style="position: absolute;top: 29.75em; left: 17em;">{{paper.page_tickets[0].issuer}}</div>
                <div class="unifyno" style="position: absolute;top: 31.35em; left: 17em;">{{paper.page_tickets[0].unifyno}}</div>
                <div class="boss" style="position: absolute;top: 32.75em; left: 17em;">{{paper.page_tickets[0].boss}}</div>
                <div class="address" style="position: absolute;top: 34.25em; left: 17em;">{{paper.page_tickets[0].address}}</div>

                <div class="bank" style="position: absolute;top: 29.75em; left: 47.85em;">{{paper.page_tickets[0].bank}}</div>
                <div class="issue_date" style="position: absolute;top: 31.35em; left: 47.85em;">{{paper.page_tickets[0].issue_date}}</div>
                <div class="credit_range" style="position: absolute;top: 32.85em; left: 47.85em;">{{paper.page_tickets[0].credit_range}}</div>
                <div class="qrcode16" style="position: absolute;top: 34.35em; left: 47.85em;">{{(paper.page_tickets[0].qrcode).substr(0,16)}}</div>          
                <!-- 必須升級成1.7版本才可以印出 -->
                <div class="qrcode" style="
                    position: absolute;
                    top:30.7em;
                    right:5em;">
                  <qrcode-vue renderAs="svg" :value="paper.page_tickets[0].qrcode" size=60 level="H"></qrcode-vue>
                </div>
              </div>

              <!-- 第二張票位置 只有一張-->
              <div v-if="paper.page_tickets.length == 1">  
                <div class="ticket_no2" style="  
                    position: absolute;
                    -webkit-transform: rotate(270deg);
                    -moz-transform: rotate(270deg);
                    -o-transform: rotate(270deg);
                    -ms-transform: rotate(270deg);
                    transform: rotate(270deg);
                    width:200px;
                    height:78px;
                    top: 61em;
                    left: -1.3em">
                  <barcode :value="paper.page_tickets[0].ticket_no" format="CODE128" width="1" height="30" font-size="10" font="Helvetica" fontOptions="normal">
                    Show this if the rendering is failed.
                  </barcode>
                </div>
                <div class="order_no_qrcode" style="position: absolute;width:200px;height:78px;top: 39.6em; left: 48em;">
                  <barcode :value='order_item.order_id' format="CODE128" width="1" height="20" font-size="10" font="Helvetica" fontOptions="normal" style="font-weight: 600">
                    Show this if the rendering is failed.
                  </barcode>
                </div>
                <!-- 新增NI條碼 -->
                <div class="p2only1" style="position: absolute;width:200px;height:78px;top: 46.5em; left: 48em;">
                  <barcode :value='paper.page_tickets[0].ns_item_id' format="CODE128" width="1" height="20" font-size="10" font="Helvetica" fontOptions="normal" style="font-weight: 600">
                    Show this if the rendering is failed.
                  </barcode>
                </div>
                <div class="total_no" style="position: absolute;top: 41.9em; left: 18.5em">{{order_item.paper_batch_no}}</div> 
                <div class="order_no" style="position: absolute;top: 41.9em; left: 39.8em">{{ order_item.order_id }} *</div>
                <div class="prod_name" style="position: absolute;top:43.65em; left: 18em;">{{paper.page_tickets[0].product_name}}</div>
                <div class="prodcut_remark1" style="position: absolute;top: 45.3em; left: 18em;">{{paper.page_tickets[0].prodcut_remark1}}</div>
                <div class="sale_price" style="position: absolute;top: 47.4em; left: 20em;">{{paper.page_tickets[0].sale_price}}</div>
                <div class="end_date" style="position: absolute;top: 47.4em; left: 35em;">{{paper.page_tickets[0].end_date}}</div>
                <div class="prodcut_remark2" style="position: absolute;top: 51.25em; left: 13em;height:31mm; text-align: left; line-height:1; width: 75%; overflow-y: hidden" v-html="paper.page_tickets[0].prodcut_remark2">
                </div>

                <div class="servicer_name" style="position: absolute;top: 62.3em; left: 20em;">{{paper.page_tickets[0].servicer_name}}</div>
                <div class="servicer_tel" style="position: absolute;top: 63.65em; left: 20em;">{{paper.page_tickets[0].servicer_tel}}</div>
                <div class="servicer_issuer" style="position: absolute;top: 63.65em; left: 40em;"> • 負責人：{{paper.page_tickets[0].servicer_issuer}}</div>
                <div class="servicer_address" style="position: absolute;top: 65.35em; left: 20em;">{{paper.page_tickets[0].servicer_address}}</div>

                <div class="issuer" style="position: absolute;top: 68.3em; left: 17em;">{{paper.page_tickets[0].issuer}}</div>
                <div class="unifyno" style="position: absolute;top: 69.8em; left: 17em;">{{paper.page_tickets[0].unifyno}}</div>
                <div class="boss" style="position: absolute;top: 71.3em; left: 17em;">{{paper.page_tickets[0].boss}}</div>
                <div class="address" style="position: absolute;top: 72.8em; left: 17em;">{{paper.page_tickets[0].address}}</div>

                <div class="bank" style="position: absolute;top: 68.1em; left: 47.9em;">{{paper.page_tickets[0].bank}}</div>
                <div class="issue_date" style="position: absolute;top: 69.95em; left: 47.85em;">{{paper.page_tickets[0].issue_date}}</div>
                <div class="credit_range" style="position: absolute;top: 71.45em; left: 47.9em;">{{paper.page_tickets[0].credit_range}}</div>
                <div class="qrcode16" style="position: absolute;top: 72.95em; left: 47.9em;">{{(paper.page_tickets[0].qrcode).substr(0,16)}}</div> 
    
                <div class="qrcode2" style="
                    position: absolute;
                    top:68.5em;
                    right:5em;">
                  <qrcode-vue renderAs="svg" :value="paper.page_tickets[0].qrcode" size=60 level="H"></qrcode-vue>
                </div>
              </div> 
              <div v-if="paper.page_tickets.length == 2">  
                <!-- 第二張票位置 有兩張的時候-->
                <div class="ticket_no2" style="  
                    position: absolute;
                    -webkit-transform: rotate(270deg);
                    -moz-transform: rotate(270deg);
                    -o-transform: rotate(270deg);
                    -ms-transform: rotate(270deg);
                    transform: rotate(270deg);
                    width:200px;
                    height:78px;
                    top: 61em;
                    left:-1.3em;">
                  <barcode :value="paper.page_tickets[1].ticket_no" format="CODE128" width="1" height="30" font-size="10" font="Helvetica" fontOptions="normal">
                    Show this if the rendering is failed.
                  </barcode>
                </div>
                <div class="order_no_qrcode" style="position: absolute;width:200px;height:78px;top: 39.6em; left: 48em;">
                  <barcode :value='order_item.order_id' format="CODE128" width="1" height="20" font-size="10" font="Helvetica" fontOptions="normal" style="font-weight: 600">
                    Show this if the rendering is failed.
                  </barcode>
                </div>
                <!-- 新增NI條碼 -->
                <div class="p2have2" style="position: absolute;width:200px;height:78px;top: 46.5em; left: 48em;">
                  <barcode :value='paper.page_tickets[1].ns_item_id' format="CODE128" width="1" height="20" font-size="10" font="Helvetica" fontOptions="normal" style="font-weight: 600">
                    Show this if the rendering is failed.
                  </barcode>
                </div>
                <div class="total_no" style="position: absolute;top:41.9em; left: 18.5em;">{{order_item.paper_batch_no}}</div> 
                <div class="order_no" style="position: absolute;top:41.9em; left: 39.8em;">{{ order_item.order_id }} *</div>
                <div class="prod_name" style="position: absolute;top:43.65em; left: 18em;">{{ paper.page_tickets[1].product_name }}</div>
                <div class="prodcut_remark1" style="position: absolute;top: 45.3em; left: 18em;">{{ paper.page_tickets[1].prodcut_remark1 }}</div>
                <div class="sale_price" style="position: absolute;top: 47.4em; left: 20em;">{{ paper.page_tickets[1].sale_price }}</div>
                <div class="end_date" style="position: absolute;top: 47.4em; left: 35em;">{{ paper.page_tickets[1].end_date }}</div>
                <!-- 需限定列印範圍不得超出 -->
                <div class="prodcut_remark2" style="position: absolute;top: 51.25em; left: 13em; height:31mm; text-align: left; line-height:1; width: 75%; overflow-y: hidden" v-html="paper.page_tickets[1].prodcut_remark2">
                </div>
                
                <div class="servicer_name" style="position: absolute;top: 62.3em; left: 20em;">{{paper.page_tickets[1].servicer_name}}</div>
                <div class="servicer_tel" style="position: absolute;top: 63.65em; left: 20em;">{{paper.page_tickets[1].servicer_tel}}</div>
                <div class="servicer_issuer" style="position: absolute;top: 63.65em; left: 40em;"> • 負責人：{{paper.page_tickets[1].servicer_issuer}}</div>
                <div class="servicer_address" style="position: absolute;top: 65.35em; left: 20em;">{{paper.page_tickets[1].servicer_address}}</div>

                <div class="issuer" style="position: absolute;top: 68.3em; left: 17em;">{{paper.page_tickets[1].issuer}}</div>
                <div class="unifyno" style="position: absolute;top: 69.8em; left: 17em;">{{paper.page_tickets[1].unifyno}}</div>
                <div class="boss" style="position: absolute;top: 71.3em; left: 17em;">{{paper.page_tickets[1].boss}}</div>
                <div class="address" style="position: absolute;top: 72.8em; left: 17em;">{{paper.page_tickets[1].address}}</div>

                <div class="bank" style="position: absolute;top: 68.1em; left: 47.9em;">{{paper.page_tickets[1].bank}}</div>
                <div class="issue_date" style="position: absolute;top: 69.95em; left: 47.85em;">{{paper.page_tickets[1].issue_date}}</div>
                <div class="credit_range" style="position: absolute;top: 71.45em; left: 47.9em;">{{paper.page_tickets[1].credit_range}}</div>
                <div class="qrcode16" style="position: absolute;top: 72.95em; left: 47.9em;">{{(paper.page_tickets[1].qrcode).substr(0,16)}}</div> 
          
                <div class="qrcode2" style="
                    position: absolute;
                    top: 68.5em;
                    right:5em;">
                  <qrcode-vue renderAs="svg" :value="paper.page_tickets[1].qrcode" size=60 level="H"></qrcode-vue>
                </div>
              </div> 

              <!-- 出貨標籤 TCA Paper order_index == 0-->
            <div v-if="(payway_selected == 'TAP' || payway_selected == 'TCA')&& freightway_selected == 'TCA' && printway_selected == '0' && paperway_selected == 'Paper' && index == 0">
              <div style="position: absolute; top: 76.5em; left: 0em; width: 100%; display: flex;">
                <div class="left" style="width: 45%; height: 307px;padding: 10px; padding-top: 25px; line-height: 1;">
                  <div class="last_block1" style="display: flex; justify-content: space-between; margin-bottom: 5px;">
                    <p style="width: 5%; border: 1px solid black; margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline; display: flex;text-align: center; align-items: center; ">黏貼聯</p>
                    <img style="width: 15%;" src="https://www.brandinlabs.com/wp-content/uploads/2019/12/%E6%97%A5%E6%9C%AC%E9%BB%91%E8%B2%93%E5%AE%85%E6%80%A5%E4%BE%BF%EF%BC%88%E5%A4%A7%E5%92%8C%E9%81%8B%E8%BC%B8%EF%BC%89%EF%BC%88YAMATO-%EF%BC%89%E6%99%82%E9%9A%9428%E5%B9%B4%E7%82%BA%E9%BB%91%E7%99%BD%E8%B2%93%E6%9B%B4%E6%8F%9B%E6%96%B0%E9%80%A0%E5%9E%8B-3.png" alt="">
                    <div style="width:  35%; display: flex; flex-direction: column; align-items: start; justify-content: space-between">
                      <p style="margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline;">黑貓宅急便客服專線</p>
                      <p style="margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline;">412-8888(手機直撥請加 02)</p>
                      <br>
                      <p style="margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline;">收貨日 {{now_year}}年 {{now_month}}月 {{now_date}}日</p>
                    </div>
                    <div style="width: 42%;display: flex;flex-direction: column; text-align: left;">
                      <div style="border: 1px solid black; padding: 2px;">
                        <p style="margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline;">包裹查詢號碼</p>
                        <p style="font-size: 18px; font-weight: bold; margin: 0; padding: 0;vertical-align: baseline;">{{order_item.ns_logistic_no}}</p>
                      </div>
                      <p style="margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline;">網路查詢包裹: <br>www.t-cat.com.tw</p>
                    </div>
                  </div> 
                  <div class="last_block2" style="display: flex; justify-content: start;">
                    <div class="left" style="width: 77%; margin-right: 5px; text-align: left">
                      <div class="line1" style="display: flex; justify-content: start; height: 40px; border: 1px solid black; border-bottom: 0px;">
                        <p style="width: 6%; border-right: 1px solid black;margin: 0; padding: 0; font-size: 100%; font: inherit;vertical-align: baseline; display:flex; align-items:center; text-align: center">收件人</p>
                        <p style="width: 94%; font-size: 14px; display:flex; align-items:center; margin: 0; padding: 0; padding-left: 2px; vertical-align: baseline;">
                          {{order_item.ns_ship_address}}<br>
                          {{order_item.ns_receiver_name}}  {{order_item.ns_receiver_mobile}}
                        </p>
                      </div>
                      <div class="line2" style="display: flex; justify-content: start; height: 40px; border: 1px solid black; border-bottom: 0px;">
                        <p style="width: 6%; border-right: 1px solid black; margin: 0; padding: 0; font-size: 100%; font: inherit;vertical-align: baseline; display:flex; align-items:center; text-align: center">寄件人</p>
                        <p style="width: 94%; display:flex; align-items:center; margin: 0; padding: 0;  padding-left: 2px; font-size: 100%; font: inherit;vertical-align: baseline;">
                          耐德全球運籌股份有限公司<br>
                          02-7728-6999<br>
                          台北市中正區博愛路38號4樓  
                        </p>
                      </div>
                      <div class="line3" style="display: flex; justify-content: start; height: 25px; border: 1px solid black; border-bottom: 0px;">
                        <p style="width: 6%; border-right: 1px solid black;margin: 0; padding: 0; font-size: 100%; font: inherit;vertical-align: baseline; display:flex; align-items:center; text-align: center">備註</p>
                        <p style="width: 94%; display:flex; align-items:center; margin: 0; padding: 0;  padding-left: 2px; font-size: 100%; font: inherit;vertical-align: baseline;"></p>
                      </div>
                      <div class="line4" style="display: flex; justify-content: start; height: 25px; border: 1px solid black;">
                        <p style="width: 6%; border-right: 1px solid black; margin: 0; padding: 0; font-size: 100%; font: inherit;vertical-align: baseline; display:flex; align-items:center; text-align: center">品名</p>
                        <p style="width: 94%; display:flex; align-items:center; margin: 0; padding: 0;  padding-left: 2px; font-size: 100%; font: inherit;vertical-align: baseline;">百貨商品</p>
                      </div>
                    </div>
                    <div class="right" style="width: 23%;">
                      <div class="line5" style="height: 40px; border: 1px solid black; border-bottom: 0px;">
                        <p style="border-bottom: 1px solid black; height: 15px; margin: 0; padding: 0; font-size: 100%; font: inherit;vertical-align: baseline; text-align: center">預定配達日</p>
                        <p style="height: 25px; display:flex; justify-content:center;align-items:center; margin: 0; padding: 0; vertical-align: baseline;">{{next_day_year}}年 {{next_day_month}}月 {{next_day_date}}日 </p>
                      </div>
                      <div class="line6" style="height: 40px; border: 1px solid black; border-bottom: 0px;">
                        <p style="border-bottom: 1px solid black; height: 15px; margin: 0; padding: 0; font-size: 100%; font: inherit;vertical-align: baseline; text-align: center">指定送達時段</p>
                        <p style="height: 25px; font-size: 16px; display:flex; justify-content:center;align-items:center; margin: 0; padding: 0;vertical-align: baseline;"></p>
                      </div>
                      <div class="line7" style="height: 50px; border: 1px solid black;">
                        <p style="border-bottom: 1px solid black; height: 15px; margin: 0; padding: 0; font-size: 100%; font: inherit;vertical-align: baseline; text-align: center">尺寸</p>
                        <p style="height: 35px; font-size: 16px; display:flex; justify-content:center;align-items:center; margin: 0; padding: 0; vertical-align: baseline;">60cm</p>
                      </div>
                    </div>
                  </div> 
                  <div class="last_block3" style="display: flex; text-align:left">
                    <div class="left" style="width:40%; border: 1px solid black; border-right: 0px">
                      <div class="top" style="height: 35px; border-bottom: 1px solid black;">
                        <p style="margin: 0; padding: 0; padding-bottom: 2px; font-size: 100%; font: inherit;vertical-align: baseline;">訂單編號</p>
                        <p style="font-size: 14px; text-align:center; margin: 0; padding: 0; font-size: 100%; font: inherit;vertical-align: baseline;"> {{order_item.order_id}} </p>
                      </div>
                      <div class="bottom" style="height: 35px;">
                        <p style="margin: 0; padding: 0; font-size: 100%; font: inherit;vertical-align: baseline;">發貨所</p>
                        <p style="font-size: 14px; text-align:center; margin: 0; padding: 0; font-size: 100%; font: inherit;vertical-align: baseline;">1016 土城所</p>
                      </div>
                    </div>
                    <div class="right" style="width:60%; border: 1px solid black;">
                      <div class="top" style="border-bottom: 1px solid black; height: 35px;">
                        <p style="margin: 0; padding: 0; font-size: 100%; font: inherit;vertical-align: baseline;">客戶代碼</p>
                        <div class="company" style="width: 100%;height:12px; display: flex; align-items: center; justify-content: center; ">
                          <barcode :value='7054950003' background="transparent" format="CODE128" width="1" height="12" font-size="10" font="Helvetica" fontOptions="normal" style="font-weight: 600">
                            Show this if the rendering is failed.
                          </barcode>
                        </div>
                        <!-- <p style="font-size: 14px; text-align:center">buyer_mi</p> -->
                      </div>
                      <div class="bottom" style="height: 35px;">
                        <p style="margin: 0; padding: 0; font-size: 100%; font: inherit;vertical-align: baseline;">代收貨款</p>
                        <p style="font-size: 14px; text-align:center; margin: 0; padding: 0; font-size: 100%; font: inherit;vertical-align: baseline;">   {{Math.round(order_item.logistic_collect_amount)}} 元</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="right" style="width: 42%; height: 307px;padding: 10px; padding-top: 25px;line-height: 1;">
                  <div class="last_block1" style="display: flex; justify-content: space-between; margin-bottom: 5px; height: 60px;">
                    <p style="width: 5%; border: 1px solid black; margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline; display: flex;text-align: center; align-items: center; ">配送聯</p>
                    <img style="width: 15%;" src="https://www.brandinlabs.com/wp-content/uploads/2019/12/%E6%97%A5%E6%9C%AC%E9%BB%91%E8%B2%93%E5%AE%85%E6%80%A5%E4%BE%BF%EF%BC%88%E5%A4%A7%E5%92%8C%E9%81%8B%E8%BC%B8%EF%BC%89%EF%BC%88YAMATO-%EF%BC%89%E6%99%82%E9%9A%9428%E5%B9%B4%E7%82%BA%E9%BB%91%E7%99%BD%E8%B2%93%E6%9B%B4%E6%8F%9B%E6%96%B0%E9%80%A0%E5%9E%8B-3.png" alt="">
                    <div style="width: 44%;">
                    </div>
                    <div style="width: 35%;display: flex;flex-direction: column; text-align: right;justify-content: space-between;">
                      <p style="font-size: 30px; margin: 0; padding: 0;vertical-align: baseline;">31-234-53</p>
                      <br>
                      <p style="margin: 0; padding: 0; font-size: 100%; font: inherit;vertical-align: baseline;">收貨日 {{now_year}}年 {{now_month}}月 {{now_date}}日</p>
                    </div>
                  </div>   
                  <div class="last_block2" style="display: flex; justify-content: start;">
                    <div class="left" style="width: 77%; margin-right: 5px; text-align: left">
                      <div class="line1" style="display: flex; justify-content: start; height: 40px; border: 1px solid black; border-bottom: 0px">
                        <p style="width: 6%; border-right: 1px solid black; text-align: center; margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline; ">收件人</p>
                        <p style="width: 94%; font-size: 14px; display:flex; align-items:center; margin: 0; padding: 0; padding-left: 2px; vertical-align: baseline; ">
                          {{order_item.ns_ship_address}}<br>
                          {{order_item.ns_receiver_name}}  {{order_item.ns_receiver_mobile}}
                        </p>
                      </div>
                      <div class="line2" style="display: flex; justify-content: start; height: 40px; border: 1px solid black; border-bottom: 0px">
                        <p style="width: 6%; border-right: 1px solid black; text-align: center; margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline; ">寄件人</p>
                        <p style="width: 94%; display:flex; align-items:center; margin: 0; padding: 0; padding-left: 2px; font-size: 100%;font: inherit;vertical-align: baseline; ">
                          耐德全球運籌股份有限公司<br>
                          02-7728-6999<br>
                          台北市中正區博愛路38號4樓  
                        </p>
                      </div>
                      <div class="line3" style="display: flex; justify-content: start; height: 25px; border: 1px solid black; border-bottom: 0px">
                        <p style="width: 6%; border-right: 1px solid black; text-align: center; margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline; ">備註</p>
                        <p style="width: 94%; display:flex; align-items:center; margin: 0; padding: 0; padding-left: 2px; font-size: 100%;font: inherit;vertical-align: baseline; "></p>
                      </div>
                      <div class="line4" style="display: flex; justify-content: start; height: 25px; border: 1px solid black; border-bottom: 1px solid black; ">
                        <p style="width: 6%; border-right: 1px solid black; text-align: center; margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline; ">品名</p>
                        <p style="width: 94%; display:flex; align-items:center; margin: 0; padding: 0; padding-left: 2px; font-size: 100%;font: inherit;vertical-align: baseline; ">百貨商品</p>
                      </div>
                    </div>
                    <div class="right" style="width: 23%;">
                      <div class="line5" style="height: 40px; border: 1px solid black; border-bottom: 0px;">
                        <p style="border-bottom: 1px solid black; height: 15px; margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline; text-align: center">預定配達日</p>
                        <p style="height: 25px; display:flex; justify-content:center;align-items:center; margin: 0; padding: 0;vertical-align: baseline; ">{{next_day_year}}年 {{next_day_month}}月 {{next_day_date}}日</p>
                      </div>
                      <div class="line6" style="height: 40px; border: 1px solid black; border-bottom: 0px;">
                        <p style="border-bottom: 1px solid black; height: 15px; margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline; text-align: center">指定送達時段</p>
                        <p style="height: 25px; font-size: 16px; display:flex; justify-content:center;align-items:center; margin: 0; padding: 0;vertical-align: baseline; "></p>
                      </div>
                      <div class="line7" style="height: 50px; border: 1px solid black;">
                        <p style="border-bottom: 1px solid black; height: 15px; margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline; text-align: center">尺寸</p>
                        <p style="height: 35px; font-size: 16px; display:flex; justify-content:center;align-items:center; margin: 0; padding: 0; vertical-align: baseline; ">60cm</p>
                      </div>
                    </div>
                  </div>                   
                  <div class="last_block3" style="display: flex;">
                    <div class="left" style="width: 30%; border: 1px solid black">
                      <div class="top" style="display:flex; height: 35px; border-bottom: 1px solid black">
                        <p style="width: 16%; border-right: 1px solid black; display:flex; align-items:center; text-align: center; margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline; ">代貨</p>
                        <p style="width: 84%;font-size: 14px;  display:flex; align-items:center; justify-content: center; margin: 0; padding: 0; vertical-align: baseline; ">{{Math.round(order_item.logistic_collect_amount)}} 元</p>
                      </div>
                      <div class="bottom" style="height: 35px;">
                        <p style="margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline; ">收件人簽收欄</p>
                      </div>
                    </div>
                    <div class="right" style="width: 70%; padding: 5px; display: flex; flex-direction: column; justify-content: space-between; text-align: center">
                      <div style="display: flex;">
                        <p style="margin: 0; padding:2px; font-size: 100%;font: inherit;vertical-align: baseline; display:flex; justify-content: start"> 7054950003 </p>
                        <p style="margin: 0; padding:2px; padding-left: 30px;font-size: 100%;font: inherit;vertical-align: baseline; text-align: center">{{order_item.ns_logistic_no}}</p>
                      </div>
                      <div class="ns_logistic_no" style="width: 100%;">
                        <barcode :value='order_item.ns_logistic_no' format="CODE128" width="1" height="20" font-size="0" font="Helvetica" fontOptions="normal" style="font-weight: 600">
                          Show this if the rendering is failed.
                        </barcode>
                      </div>                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
              <!-- 出貨標籤 HCT Paper order_index == 0-->
            <div v-if="(payway_selected == 'TAP' || payway_selected == 'HCT')&& freightway_selected == 'HCT' && printway_selected == '0' && paperway_selected == 'Paper' && index == 0">
              <div style="position: absolute; top: 76.5em; left: 0em; width: 100%; display: flex;">
                <div class="left" style="position: absolute; width: 45%; height: 307px; line-height: 1; padding: 10px;">
                  <div class="last_block1" style="display: flex; justify-content: space-between; margin-bottom: 5px; height: 40px; border: 1px solid black; ">
                    <img style="width: 25%; padding-right: 3px;border-right: 1px solid black;" src="../../assets/images/shin_icon.jpg" alt="">
                    <div style="width: 50%; border-right: 1px solid black; display: flex; flex-direction: column;">
                      <p style="height: 20px; width: 100%; border-bottom: 1px solid black; display:flex; justify-content: center;	align-items: center;margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline;">收貨日 {{now_year}}年 {{now_month}}月 {{now_date}}日  土城所</p>
                      <p style="height: 20px; width: 100%; display:flex; justify-content: center;	align-items: center;margin: 0; padding: 0;border: 0;font-size: 100%;font: inherit;vertical-align: baseline;">訂單編號：{{order_item.order_id}}</p>
                    </div>
                    <p style="width: 25%; margin: 0; display:flex; justify-content: center;	padding: 0;border: 0;font-size: 100%;font: inherit;vertical-align: baseline;">到著站</p>
                  </div>
                  <div class="last_block2" style="display: flex; justify-content: start;">
                    <div class="left" style="width: 80%; margin-right: 5px; text-align: left; border: 1px solid black;">
                      <div class="line1" style="display: flex; height: 60px; border-bottom: 1px solid black;">
                        <p style="width: 6%; border-right: 1px solid black; display: flex;align-items:center; text-align: center; margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline;">收件人</p>
                        <p style="width: 94%; font-size: 14px; display: flex; align-items:center; padding-left: 5px;">
                          {{order_item.ns_ship_address}}<br>
                          {{order_item.ns_receiver_name}} <br>
                          {{order_item.ns_receiver_mobile}}
                        </p>
                      </div>
                      <div class="line2" style="display: flex; height: 60px; border-bottom: 1px solid black;">
                        <p style="width: 6%; border-right: 1px solid black; display:flex; align-items:center; text-align: center; margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline;">寄件人</p>
                        <p style="width: 94%; font-size: 14px; display:flex; align-items:center; padding-left: 5px;">
                          耐德全球運籌股份有限公司<br>
                          02-7728-6999<br>
                          台北市中正區博愛路38號4樓  
                        </p>
                      </div>
                      <div class="line3" style="display: flex;height: 40px;">
                        <p style="width: 6%; border-right: 1px solid black; display:flex; align-items:center; text-align: center; margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline;">備註</p>
                        <p style="width: 94%; font-size: 14px; display:flex; display:flex; align-items:center; padding-left: 5px;">{{order_item.order_id}}</p>
                      </div>
                    </div>
                    <div class="right" style="width: 20%; border: 1px solid black;">
                      <div class="line5" style="height: 60px;">
                        <p style="border-bottom: 1px solid black; height: 20px; display:flex; justify-content:center;align-items:center; margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline;">指配日期</p>
                        <p style="border-bottom: 1px solid black; height: 40px; font-size: 16px; display:flex; justify-content:center;align-items:center; margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline;">{{next_next_day_year}}年 {{next_next_day_month}}月 {{next_next_day_date}}日</p>
                      </div>
                      <div class="line6" style="height: 50px;">
                        <p style="border-bottom: 1px solid black; height: 20px; display:flex; justify-content:center;align-items:center; margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline;">總件數</p>
                        <p style="border-bottom: 1px solid black; height: 30px; font-size: 16px; display:flex; justify-content:center;align-items:center; margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline;">1</p>
                      </div>
                      <div class="line7" style="height: 50px;">
                        <p style="border-bottom: 1px solid black; height: 20px; display:flex; justify-content:center;align-items:center; margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline;">重量</p>
                        <p style=" height: 30px; font-size: 14px; display:flex; justify-content:center;align-items:center; margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline;">10</p>
                      </div>
                    </div>
                  </div>  
                  <div class="last_block3" style="display: flex; height: 60px;">
                    <div class="left" style="width: 30%; border: 1px solid black; display: flex;">
                      <p style="margin: 0; padding-top: 2px; padding-left: 2px;font-size: 100%;font: inherit;vertical-align: baseline;">代收貨款</p>
                      <p style="font-size: 16px; font-weight: bold; line-height: 2.5; display: flex; align-items: center; margin: 0; padding: 0;font-size: 100%;font: inherit;vertical-align: baseline;">{{Math.round(order_item.logistic_collect_amount)}} 元</p>
                    </div>
                    <div class="right" style="width: 70%; border: 1px solid black">
                      <p style="text-align: left; margin: 0; padding-top: 2px; padding-left: 2px;font-size: 100%;font: inherit;vertical-align: baseline;">查貨號碼</p>
                      <div class="ns_logistic_no" style="width: 100%;height:60px; display: flex; align-items: center; justify-content: center; margin-top: -15px;">
                        <barcode :value='order_item.ns_logistic_no' format="CODE128" width="1" height="20" font-size="10" font="Helvetica" fontOptions="normal" style="font-weight: 600">
                          Show this if the rendering is failed.
                        </barcode>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="right" style="width: 45%; height: 307px; padding: 10px; line-height: 1; padding: 10px;">

                </div>
              </div>
            </div>
          </div> 
        </div>
      </div>
    </div>

    <!-- 訂單列表 ----------------------->
    <div class="text-center" v-if="table_or_ticket == 'table'">
      <!--就都用複選就好,單選與range選取的暫時不用了-->
      <!--<b-form-group label="選取方式：" label-cols-md="2">
        <b-form-select v-model="selectMode" :options="modes" class="mb-2"></b-form-select>
      </b-form-group>-->
      <div>
        <b-button 
          :disabled="selected.length==customized_orderlist.length"
          class="mr-1"
          style="float:left;"
          @click="check_all"
        >全選</b-button>
        <b-button 
          :disabled="selected.length==0"
          class="mr-1"
          style="float:left;"
          @click="uncheck_all"
        >全不選</b-button>
        
        <b-button 
          :disabled="preview_page_number==1"
          class="mr-3"
          @click="go_previous_page"
        >上一頁</b-button>
        <b-button 
          :disabled="customized_orderlist.length<preview_items_per_page"
          @click="go_next_page"
        >下一頁</b-button>
        <span
          style="float:right;display:inline-block;"
        >第{{preview_page_number}}頁</span>
      </div>
      
      <b-table
        ref="selectableTable"
        selectable
        bordered
        :select-mode="selectMode"
        :items="customized_orderlist"
        :fields="fields"
        @row-selected="onRowSelected"
        responsive="sm"
      >    
        <!-- Example scoped slot for select state illustrative purposes -->
        <template #cell(selected)="{ rowSelected }">
          <template v-if="rowSelected">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>
      </b-table>
      <div class="result" style="display:flex; justify-content: space-around; padding: 20px; margin-bottom:50px;">
        <p style="width: 70%; display:flex">
          已選訂單<br>
          {{ selected }}
        </p>
        <!-- <div style="align-items: center; display: flex">
          <button type="button" :disabled="isLoading" @click="customized_process">匯出已選訂單pdf</button>
        </div> -->
      </div>

    </div>
    <div class="overlay-container" v-show="dialog === true" @click.stop="closePopUp">
      <div @click.stop="" class="overlay-background" style="background-color:#fff;z-index:100;">
        <table border=1 width=1000px
            style="width:100%;margin-left: auto;margin-right: auto;position:absolute;"
        >
          <tbody>
            <tr>
              <th v-for="title in columns" :key="title.id" style="text-align: center;background-color: rgb(245, 245, 150);color: rgba(0,0,0,0.5); height:40px">{{title}}</th>
            </tr>
            <tr v-for="item in tableData.slice().reverse()" :key="item.id">
              <td v-for="(title, key) in columns" :key="title.id">
                <span v-if="key==='item'">{{ item.queueId }}</span>
                <span v-else-if="key==='status'" class="order_export_status" style="display:block;text-align:center;">{{ satusText(item) }}</span>
                <span v-else-if="key==='start_time'" class="order_export_start_time" style="display:block;text-align:center;">{{ item.createdAt }}</span>
                <span v-else-if="key==='expire_time'" class="order_export_end_time" style="display:block;text-align:center;">{{ item.expiredAt }}</span>
                <a v-else class="order_export_download" style="color: black;" @click="getQueueResultListById(item.queueId)">{{ satusText(item)==='執行完畢，可查看結果'?'下載結果':'請稍後再查看結果' }}</a>
              </td>
            </tr> 
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
import VueBarcode from 'vue-barcode';
import QrcodeVue from 'qrcode.vue';

import {
  apiProcessPaperTicketOrder,
  apiUpdatePaperTicketOrderNSStatus,
  apiPrintPaperTicketPdf,
  apiGetQueueNameList,
  apiGetQueueResultList,
  apiGetQueueResultListById
} from '@/api/Order.js'

export default {
  name: 'PrintTest',
  components: {
    'barcode': VueBarcode,
    QrcodeVue
  },
  data: function () {
    return {
      isLoading:false,
      tickets_to_print:[],
      payway_selected: null,
      payway_options: [
        // { value: null, text: 'Please select some item' },
        { value: null, text: '請選擇付款方式', disabled: true},
        //應該不會開超取付款風險太大
        { value: 'prepay', text: '預付(刷卡與退貨款)' },
        { value: 'postpay', text: '貨到付款' },
        //{ value: 'TAP', text: 'TAP刷卡' },
        //{ value: 'HCT', text: '新竹貨到付款' },
        //{ value: 'TCA', text: '黑貓貨到付款' },
        //{ value: 'GWF', text: '綠界刷卡' },
        //{ value: '711', text: '超商取貨(711)' },
        //{ value: 'CVS', text: '超商取貨(全家萊爾富OK)' },
      ],
      freightway_selected: null,
      freightway_options: [
        // { value: null, text: 'Please select some item' },
        { value: null, text: '請選擇配送方式', disabled: true},
        //{ value: 'Paper', text: 'Paper（訂單全為票券）' },
        //{ value: 'Other', text: 'Other（訂單含其他商品）' },
        { value: 'HCT', text: '新竹宅配' },
        { value: '711', text: '超商取貨(711)' },
        //{ value: 'CVS', text: '超商取貨(萊爾富OK)' },
        { value: 'FAM', text: '超商取貨(全家)' },
        { value: 'HIL', text: '超商取貨(萊爾富)' },
        { value: 'SPE', text: '超商取貨(蝦皮)' },
        //app還有黑貓貨到付款,所以暫時無法避免黑貓宅配出貨
        { value: 'TCA', text: '黑貓宅配' },
      ],
      paperway_selected: null,
      paperway_options: [
        // { value: null, text: 'Please select some item' },
        { value: null, text: '請選擇訂單型式', disabled: true},
        { value: 'Paper', text: 'Paper（訂單全為票券）' },
        { value: 'Other', text: 'Other（訂單含其他商品）' },
        { value: 'KTC', text: '智生活紙本票訂單' },//因為payway/freightway都是NS丟的為準...不知道KTC到底會是啥與變成啥,反正KTC都一起處理,就多一個KTC(KTC不能混實體商品)
        // { value: 'All', text: '一起處理' },
        //{ value: 'TCA', text: '黑貓宅配' },
      ],
      printway_selected: null,
      printway_options: [
        // { value: null, text: 'Please select some item' },
        { value: null, text: '請選擇產票方式', disabled: true},
        // { value: '0', text: 'All（全部直接產票）' },
        { value: '1', text: 'Customized（自選訂單產票）' }
      ],
      display_print:0,
      force_reprint:'0',
      force_batch_no:'',
      preview_items_per_page:50,
      preview_page_number:1,
      //查詢後,上一頁/下一頁時,若跳到剛剛抓過的頁數,就不用呼叫api,由這個頁數數字當key的object取出data來就好,點上面重新查詢時reset
      //這樣機制是節省api存取處理的loading,風險是如果剛好碰到有新的訂單狀態ready可列印時,分頁抓到的資料將會錯位
      //(得一直檢查總筆數,有變時從第一頁重撈才能避免,但通常是不會碰到才對,所以先不處理)
      page_cache:{},
      two_ticket: [],
      orders:[],
      modes: ['multi', 'single','range'],
      fields: [
        {key:'selected', label:'勾選'}, 
        {key:'paper_batch_no', label:'批號(已產票)'}, 
        {key:'order_id',label:'訂單編號', sortable: true}, 
        {key:'buyer_name', label:'訂購人'}, 
        {key:'order_status', label:'訂單狀態'},
        {key:'ticket_count', label:"票券張數"},
        {key:'total_amount', label:"訂單總金額"},
        {key:'total_discount_amount', label:"訂單折扣金額"},
      ],
      // items: [
      //   {need_ez_order: true, order_id: 'Dickerson', buyer_name: 'Macdonald',order_status:''},
      //   {need_ez_order: true, order_id: 'Larsen', buyer_name: 'Shaw',order_status:'' },
      //   {need_ez_order: true, order_id: 'Geneva', buyer_name: 'Wilson',order_status:''},
      //   {need_ez_order: true, order_id: 'Jami', buyer_name: 'Carney',order_status:''}
      // ],
      selectMode: 'multi',
      selected: [],
      table_or_ticket: null,
      customized_orderlist:[],
      ableToPrint: false,
      // 單據 data
      now_year:null,
      now_month:null,
      now_date:null,
      next_day_year: null,
      next_day_month:null,
      next_day_date:null,
      next_next_day_year:null,
      next_next_day_month:null,
      next_next_day_date:null,
      is_new_print: false,
      // 產票進Queue新加的data
      columns: {
        item: "執行項目",
        status: "狀態",
        start_time: "執行時間",
        expire_time: "有效期限",
        //overview: "結果總覽",
        export: "結果匯出",
        
      },
      tableData: [],
      dialog:false, 
    }
  },
  methods: {
    // restructureString(remark2) {
    //   console.log(remark2);
    //   remark2 = remark2.replaceAll("<br>","\n");
    //   console.log("後",remark2);
    //   return remark2;
    // },

    change_PI_to_NI(ticket,number){
      // 如果是PI 轉成NI
      if(number){
        if(number.substr(0,2) === "PI"){
          // ticket == 該張票
          // 從product_name 比對 NI
          // 更新：除了product_name, product_remark1 也是有可能存在NI替換
          // ** prodcut_remark1 回傳值的英文拼錯要注意 **
          let name_str = ticket.product_name;
          let remark1_str = ticket.prodcut_remark1;
          // product_name開始找
          // console.log(typeof name_str, name_str);
          // console.log(typeof remark1_str, remark1_str);
          if(name_str.includes('NI')){
            // the first position show NI
            let NI_position = name_str.indexOf('NI',0);
            if(NI_position !== -1){
              // 第一碼位置，含NI 共16碼
              let NI_num = name_str.substr(NI_position, 16);
              return NI_num;
            }
            else{
              // product_name 沒有NI 只好回傳PI
              alert("找不到NI條碼");
              return number
            }
          }
          // 沒有再從 product_remark 找
          else if(remark1_str.includes('NI')){
            let NI_position = remark1_str.indexOf('NI',0);
            if(NI_position !== -1){
              // 第一碼位置，含NI 共16碼
              let NI_num = remark1_str.substr(NI_position, 16);
              return NI_num;
            }
            else{
              // product_name 沒有NI 只好回傳PI
              alert("找不到NI條碼");
              return number
            }            
          }
          else{
            return number
          }
        }
        else{
          return number
        }
      }
      else{
        return number;
      }
    },
    go_next_page() {
      //下一頁就是...page_number+1再抓一次api那樣
      this.preview_page_number++
      if (this.page_cache[this.preview_page_number+""]) {
        //不用呼叫api直接處理
        this.selected = []
        this.customized_orderlist = this.page_cache[this.preview_page_number+""]
      }
      else {
        this.process_api('wait_order_selection')
      }
    },
    go_previous_page() {
      this.preview_page_number--
      this.selected = []
      this.customized_orderlist = this.page_cache[this.preview_page_number+""]
    },
    check_all() {
      //得用bootstrap的選取方法處理才行喔
      if (this.$refs.selectableTable) {
        this.$refs.selectableTable.selectAllRows()
      }
    },
    uncheck_all() {
      if (this.$refs.selectableTable) {
        this.$refs.selectableTable.clearSelected()
      }
    },
    onRowSelected(items) {
      // console.log(items);
      let selected_items = [];
      for(let i = 0; i < items.length; i++){
        // eslint-disable-next-line
        console.log(items[i].order_id)
        selected_items.push(items[i].order_id); 
      }
      this.selected = selected_items;
      console.log(this.selceted);
    },
    print() {
      // console.log(this);
      let target_dom_id = 'prt_area';
      let prtContent = document.getElementById(target_dom_id);
      // console.log('prtContent innerHTML', prtContent);
      //src="@/assets/css/print_ticket.css"
      let WinPrint = window.open('', '', 'left=0,top=0,width=210mm,height=297mm,toolbar=0,scrollbars=0,status=0');
      // WinPrint.document.write('<html><head><title>Print it!</title><link rel="stylesheet" type="text/css" href="../assets/css/print_ticket.css"></head><body>');
      // WinPrint.document.write('<style type="text/css">.paper {page-break-after: always;position: relative;display: block;height:29.7cm;width:21cm;}.paper-inside {  position: relative;}.ticket_no {  position: absolute;  -webkit-transform: rotate(270deg);  -moz-transform: rotate(270deg);  -o-transform: rotate(270deg);  -ms-transform: rotate(270deg);  transform: rotate(270deg);  width:200px;  height:80px;  top:20em;  left:2em;}.order_no {  position: absolute;  top:2em;  left:12em;}.prod_name {  position: absolute;  top:4em;  left:12em;}.qrcode {  position: absolute;  top:24em;  right:8em;}.ticket_no2 {  position: absolute;  -webkit-transform: rotate(270deg);  -moz-transform: rotate(270deg);  -o-transform: rotate(270deg);  -ms-transform: rotate(270deg);  transform: rotate(270deg);  width:200px;  height:80px;  top:42em;  left:2em;}.order_no2 {  position: absolute;  top:30em;  left:12em;}.prod_name2 {  position: absolute;  top:32em;  left:12em;}.qrcode2 {  position: absolute;  top:48em;  right:8em;}      </style>');
      WinPrint.document.write(prtContent.innerHTML);
      // WinPrint.document.write('</body></html>');
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    customized_process(){
      // eslint-disable-next-line
      console.log(this.selected.length);
      // if (this.payway_selected === null && this.freightway_selected == null && this.printway_selected == null) {
      //   this.openPopUp()
      //   return;
      // }

      if(this.selected.length == 0){
        this.$bus.fnShowInfo("請先勾選訂單")
        return;
      }
      this.$bus.fnShowConfirm(('本操作將產生批次號碼，請點擊"確認"以繼續'),() => {
        //this.printway_selected = 0; 
        console.log("1");
        this.process_api('print_preview')
        // this.process_api()
        this.$bus.fnClosePopup()
        // setTimeout(() => {
        //   this.openPopUp()
        // },500)
        return
      }, () => {
        console.log("2");
        this.$bus.fnClosePopup()
        return 
      })
      

      // 
      /*
      this.printway_selected = 0; 
      let Param = {
        'module':'order',
        'method':'processPaperTicketOrder',
        'freight_way': this.freightway_selected,
        'pay_way':this.payway_selected,
        'pure_paper':this.paperway_selected,
        'return_preview_orders': this.printway_selected,
        'preview_page_number': 1,
        'preview_items_per_page': 1000,
        'order_ids': this.selected,
        'force_reprint':1,
        'apiTarget':'ntsa',
      }
      let that = this;
      this.$bus.apiCall(Param, function(data) {
        if (data.ok === 0) {
          // console.log("失敗")
          that.ableToPrint = false;
          alert(data.msg)
            // vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
          return
        }
        else{
          alert("成功產票，列印前預覽");
          that.table_or_ticket = 'ticket';
          console.log(data);
          that.ableToPrint = true;
          that.orders = data.data;
          for(let i = 0; i < that.orders.length; i++){
            // 檢查每筆訂單內各需要印出幾張紙
            console.log(`第${i}張訂單`,that.orders[i].papers);

            that.orders[i].papers.forEach(item => {
              // 再檢查每張紙是1張票或是2張票
              if(item.page_tickets.length == 2){
                console.log("兩張");
                // 一頁兩張票
              }if(item.page_tickets.length == 1){
                console.log("一張");
                // 一頁一張票
              }
              // else {
              //   alert("wrong data");
              //   that.empty = null;
              //   // 不是一張也不是兩張？？？
              // }
            })
          }
        }
      })*/ 

    },
    sycn_ns_order() {
      if (this.isLoading) {
        return
      }
      let Param = {
          'module':'order',
          'method':'updatePaperTicketOrderNSStatus',
          'apiTarget':'ntsa',
        }
        let that = this;
        this.isLoading = true
        apiUpdatePaperTicketOrderNSStatus(Param).then(function(resp){
          //這個api除了網路錯誤沒有失敗理由
          that.$bus.fnShowInfo("更新完成");
          that.isLoading = false
        }).catch(function(error){
          let data = error.response.data
          if (data.ok === 0) {
            that.$bus.fnShowInfo(data.msg)
          }
        })
        // this.$bus.apiCall(Param, function(data) {
        //   if (data.ok === 0) {
        //     that.$bus.fnShowInfo(data.msg)
        //   }
        //   //這個api除了網路錯誤沒有失敗理由
        //   that.$bus.fnShowInfo("更新完成");
        //   that.isLoading = false
        // })
    },
    async process_api(post_action) {

      if (this.isLoading) {
        return
      }

      
      // force_print應只有勾選處理模式有勾選checkbox時才會是1
      let force_print = (post_action == 'wait_order_selection'?this.force_reprint:this.selected?this.force_reprint:'0');
      let force_batch_no = (post_action == 'wait_order_selection'?this.force_batch_no:this.selected?this.force_batch_no:'');
      let selected_ids = (post_action == 'print_preview' && this.printway_selected == 1 && this.selected)?this.selected:'';
      //return_preview_orders由post_action決定,不與UI操作選項綁定

      
      let Param = {
          // 'module':'order',
          'method':'processPaperTicketOrder',
          'freight_way': this.freightway_selected,
          'pay_way':this.payway_selected,
          'pure_paper':this.paperway_selected,
          'return_preview_orders':(post_action=='print_preview'?0:1),
          'preview_page_number': this.preview_page_number,
          'preview_items_per_page': this.preview_items_per_page,
          'order_ids': selected_ids !== ''? selected_ids.join(','):selected_ids,
          'force_reprint':force_print,
          'force_batch_no':force_batch_no,
          'apiTarget':'ntsa',
          'is_queue_print': (post_action=='print_preview' || this.selected.length>0?1:0),
        }
        let that = this;
        this.isLoading = true

        await apiPrintPaperTicketPdf(Param).then(function(resp){
          console.log('新新新')
          console.log(resp)
          let data = resp.data
          console.log(data.data);
          if (that.selected.length > 0) {
            that.$bus.fnShowInfo('已產生批號 : ' + data.msg + '，' + "請稍等一下之後點擊查看所有產票結果查詢");  

          }
          // 查詢單個Queue結果 issue : http://redmine.nineder.com:8080/issues/18373
          // if (resp['data']['msg'] !== "") {
          //   console.log('935行','有取得Queueid')
          //   let queueId = resp['data']['msg']
          //   apiGetQueueResultListById(queueId).then((resp) => {
          //     console.log(resp)
          //     // that.$bus.fnShowInfo(data.msg)

          //   }).catch( (error) => {
          //     console.log(error)
          //   })
          // }

          if (data.data === undefined) {
            alert(data.msg)
            // alert("1")

            // console.log("失敗")
            that.ableToPrint = false;
            //confirm時彈不出來
            that.$bus.fnShowInfo(data.msg)
              // vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            //清空
            that.orders = [];
            if (post_action == 'wait_order_selection' && data.msg == '無待處理訂單') {
              that.customized_orderlist = []
            }
            return
          }

          //失敗時的table_or_ticket沒有對應,全部處理執行失敗會殘留之前勾選處理列表,所以提到最上面判斷掉
          that.table_or_ticket = post_action == 'wait_order_selection'?'table':'ticket';
          // that.table_or_ticket = 'ticket';
          // if (resp.data.msg !== "") {

            /*
            if (post_action == 'print_preview') {
              // alert('2')
              if (that.check_process_print(data.data) === false) {
                that.$bus.fnShowInfo("產票結果含問題訂單(票券課程)，請用"+data.data[0].paper_batch_no+'查看狀態不是print_to_deliver的訂單，請業務確認訂單商品藍新是否正確上架，處理完成後再用此批號重新操作一次');  
                //不要繼續處理
                that.ableToPrint = false;
                return 
              }
              that.$bus.fnShowInfo("成功產票，列印前預覽 "+data.msg);
              // alert("成功產票，列印前預覽");
              //that.table_or_ticket = 'ticket';
              // eslint-disable-next-line
              console.log(data)
              that.ableToPrint = true;
              
              that.orders = data.data
              // 當下時間
              let now = new Date();
              let next_day = new Date();
              let next_next_day = new Date();
              // alert(now);
              that.now_year = now.getFullYear();
              that.now_month = now.getMonth() +1;  // 0 開始
              that.now_date = now.getDate();
              // 指定配送日隔天
              next_day.setDate(next_day.getDate()+1);

              that.next_day_year = next_day.getFullYear();
              that.next_day_month = next_day.getMonth() + 1;
              that.next_day_date = next_day.getDate();
              // 指定配送日隔兩天
              next_next_day.setDate(next_next_day.getDate()+2);

              that.next_next_day_year = next_next_day.getFullYear();
              that.next_next_day_month = next_next_day.getMonth() +1;
              that.next_next_day_date = next_next_day.getDate();


              //下面只是debug code而已
              for(let i = 0; i < that.orders.length; i++){
                // 檢查每筆訂單內各需要印出幾張紙
                // eslint-disable-next-line
                console.log(`第${i}張訂單`,that.orders[i].papers);

                that.orders[i].papers.forEach(item => {
                  // 再檢查每張紙是1張票或是2張票
                  if(item.page_tickets.length == 2){
                    // eslint-disable-next-line
                    console.log("兩張");
                    // 一頁兩張票
                  }if(item.page_tickets.length == 1){
                    // eslint-disable-next-line
                    console.log("一張");
                    // 一頁一張票
                  }
                  // else {
                  //   alert("wrong data");
                  //   that.empty = null;
                  //   // 不是一張也不是兩張？？？
                  // }
                })
              }
            }
            */
            if (post_action == 'wait_order_selection') {
              //that.table_or_ticket = 'table';
              // alert("抓訂單成功");
              that.$bus.fnShowInfo("抓訂單成功");
              // eslint-disable-next-line
              console.log(data.data);
              that.page_cache[that.preview_page_number] = data.data
              that.customized_orderlist = data.data;
              //b-table會殘留之前的data和選取狀態,這很不好,所以全部清除掉
              that.uncheck_all()
              that.selected = []
            }
          // }  
        }).catch(function(error){
          let data = error.response.data
          //失敗時的table_or_ticket沒有對應,全部處理執行失敗會殘留之前勾選處理列表,所以提到最上面判斷掉
          that.table_or_ticket = post_action == 'wait_order_selection'?'table':'ticket';

          if (data.ok === 0) {
            // alert(data.msg)
            // console.log("失敗")
            that.ableToPrint = false;
            //confirm時彈不出來
            that.$bus.fnShowInfo(data.msg)
              // vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            //清空
            that.orders = [];
            if (post_action == 'wait_order_selection' && data.msg == '無待處理訂單') {
              that.customized_orderlist = []
            }
            return
          }
        })
        this.isLoading = false
        
        
        // apiGetQueueNameList().then((resp) => {
        //   console.log(resp)
        // }).catch((error) => {
        //   console.log(error)
        // })

        // apiGetQueueResultList().then((resp) => {
        //   console.log(resp)
        // }).catch((error) => {
        //   console.log(error)
        // })
        
        

        // apiProcessPaperTicketOrder(Param).then(function(resp){
        //   console.log(resp)
        //   let data = resp.data

        //   if (data.data === undefined) {
        //     // alert(data.msg)
        //     // console.log("失敗")
        //     that.ableToPrint = false;
        //     //confirm時彈不出來
        //     that.$bus.fnShowInfo(data.msg)
        //       // vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
        //     //清空
        //     that.orders = [];
        //     if (post_action == 'wait_order_selection' && data.msg == '無待處理訂單') {
        //       that.customized_orderlist = []
        //     }
        //     return
        //   }

        //   //失敗時的table_or_ticket沒有對應,全部處理執行失敗會殘留之前勾選處理列表,所以提到最上面判斷掉
        //   that.table_or_ticket = post_action == 'wait_order_selection'?'table':'ticket';
        //     if (post_action == 'print_preview') {
        //       if (that.check_process_print(data.data) === false) {
        //         that.$bus.fnShowInfo("產票結果含問題訂單(票券課程)，請用"+data.data[0].paper_batch_no+'查看狀態不是print_to_deliver的訂單，請業務確認訂單商品藍新是否正確上架，處理完成後再用此批號重新操作一次');  
        //         //不要繼續處理
        //         that.ableToPrint = false;
        //         return 
        //       }
        //       that.$bus.fnShowInfo("成功產票，列印前預覽 "+data.msg);
        //       // alert("成功產票，列印前預覽");
        //       //that.table_or_ticket = 'ticket';
        //       // eslint-disable-next-line
        //       console.log(data)
        //       that.ableToPrint = true;
        //       that.orders = data.data
        //       // 當下時間
        //       let now = new Date();
        //       let next_day = new Date();
        //       let next_next_day = new Date();
        //       // alert(now);
        //       that.now_year = now.getFullYear();
        //       that.now_month = now.getMonth() +1;  // 0 開始
        //       that.now_date = now.getDate();
        //       // 指定配送日隔天
        //       next_day.setDate(next_day.getDate()+1);

        //       that.next_day_year = next_day.getFullYear();
        //       that.next_day_month = next_day.getMonth() + 1;
        //       that.next_day_date = next_day.getDate();
        //       // 指定配送日隔兩天
        //       next_next_day.setDate(next_next_day.getDate()+2);

        //       that.next_next_day_year = next_next_day.getFullYear();
        //       that.next_next_day_month = next_next_day.getMonth() +1;
        //       that.next_next_day_date = next_next_day.getDate();


        //       //下面只是debug code而已
        //       for(let i = 0; i < that.orders.length; i++){
        //         // 檢查每筆訂單內各需要印出幾張紙
        //         // eslint-disable-next-line
        //         console.log(`第${i}張訂單`,that.orders[i].papers);

        //         that.orders[i].papers.forEach(item => {
        //           // 再檢查每張紙是1張票或是2張票
        //           if(item.page_tickets.length == 2){
        //             // eslint-disable-next-line
        //             console.log("兩張");
        //             // 一頁兩張票
        //           }if(item.page_tickets.length == 1){
        //             // eslint-disable-next-line
        //             console.log("一張");
        //             // 一頁一張票
        //           }
        //           // else {
        //           //   alert("wrong data");
        //           //   that.empty = null;
        //           //   // 不是一張也不是兩張？？？
        //           // }
        //         })
        //       }
        //     }
        //     else if (post_action == 'wait_order_selection') {
        //       //that.table_or_ticket = 'table';
        //       // alert("抓訂單成功");
        //       that.$bus.fnShowInfo("抓訂單成功");
        //       // eslint-disable-next-line
        //       console.log(data.data);
        //       that.page_cache[that.preview_page_number] = data.data
        //       that.customized_orderlist = data.data;
        //       //b-table會殘留之前的data和選取狀態,這很不好,所以全部清除掉
        //       that.uncheck_all()
        //       that.selected = []
        //     }
        // }).catch(function(error){
        //   let data = error.response.data
        //   //失敗時的table_or_ticket沒有對應,全部處理執行失敗會殘留之前勾選處理列表,所以提到最上面判斷掉
        //   that.table_or_ticket = post_action == 'wait_order_selection'?'table':'ticket';

        //   if (data.ok === 0) {
        //     // alert(data.msg)
        //     // console.log("失敗")
        //     that.ableToPrint = false;
        //     //confirm時彈不出來
        //     that.$bus.fnShowInfo(data.msg)
        //       // vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
        //     //清空
        //     that.orders = [];
        //     if (post_action == 'wait_order_selection' && data.msg == '無待處理訂單') {
        //       that.customized_orderlist = []
        //     }
        //     return
        //   }
        // })
        // this.isLoading = false
        // this.$bus.apiCall(Param, function(data) {
        //   //失敗時的table_or_ticket沒有對應,全部處理執行失敗會殘留之前勾選處理列表,所以提到最上面判斷掉
        //   that.table_or_ticket = post_action == 'wait_order_selection'?'table':'ticket';
        //   that.isLoading = false
        //   if (data.ok === 0) {
        //     // alert(data.msg)
        //     // console.log("失敗")
        //     that.ableToPrint = false;
        //     //confirm時彈不出來
        //     that.$bus.fnShowInfo(data.msg)
        //       // vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
        //     //清空
        //     that.orders = [];
        //     if (post_action == 'wait_order_selection' && data.msg == '無待處理訂單') {
        //       that.customized_orderlist = []
        //     }
        //     return
        //   }
        //   else{
        //     if (post_action == 'print_preview') {
        //       if (that.check_process_print(data.data) === false) {
        //         that.$bus.fnShowInfo("產票結果含問題訂單(票券課程)，請用"+data.data[0].paper_batch_no+'查看狀態不是print_to_deliver的訂單，請業務確認訂單商品藍新是否正確上架，處理完成後再用此批號重新操作一次');  
        //         //不要繼續處理
        //         that.ableToPrint = false;
        //         return 
        //       }
        //       that.$bus.fnShowInfo("成功產票，列印前預覽 "+data.msg);
        //       // alert("成功產票，列印前預覽");
        //       //that.table_or_ticket = 'ticket';
        //       // eslint-disable-next-line
        //       console.log(data)
        //       that.ableToPrint = true;
        //       that.orders = data.data
        //       // 當下時間
        //       let now = new Date();
        //       let next_day = new Date();
        //       let next_next_day = new Date();
        //       // alert(now);
        //       that.now_year = now.getFullYear();
        //       that.now_month = now.getMonth() +1;  // 0 開始
        //       that.now_date = now.getDate();
        //       // 指定配送日隔天
        //       next_day.setDate(next_day.getDate()+1);

        //       that.next_day_year = next_day.getFullYear();
        //       that.next_day_month = next_day.getMonth() + 1;
        //       that.next_day_date = next_day.getDate();
        //       // 指定配送日隔兩天
        //       next_next_day.setDate(next_next_day.getDate()+2);

        //       that.next_next_day_year = next_next_day.getFullYear();
        //       that.next_next_day_month = next_next_day.getMonth() +1;
        //       that.next_next_day_date = next_next_day.getDate();


        //       //下面只是debug code而已
        //       for(let i = 0; i < that.orders.length; i++){
        //         // 檢查每筆訂單內各需要印出幾張紙
        //         // eslint-disable-next-line
        //         console.log(`第${i}張訂單`,that.orders[i].papers);

        //         that.orders[i].papers.forEach(item => {
        //           // 再檢查每張紙是1張票或是2張票
        //           if(item.page_tickets.length == 2){
        //             // eslint-disable-next-line
        //             console.log("兩張");
        //             // 一頁兩張票
        //           }if(item.page_tickets.length == 1){
        //             // eslint-disable-next-line
        //             console.log("一張");
        //             // 一頁一張票
        //           }
        //           // else {
        //           //   alert("wrong data");
        //           //   that.empty = null;
        //           //   // 不是一張也不是兩張？？？
        //           // }
        //         })
        //       }
        //     }
        //     else if (post_action == 'wait_order_selection') {
        //       //that.table_or_ticket = 'table';
        //       // alert("抓訂單成功");
        //       that.$bus.fnShowInfo("抓訂單成功");
        //       // eslint-disable-next-line
        //       console.log(data.data);
        //       that.page_cache[that.preview_page_number] = data.data
        //       that.customized_orderlist = data.data;
        //       //b-table會殘留之前的data和選取狀態,這很不好,所以全部清除掉
        //       that.uncheck_all()
        //       that.selected = []
        //     }
        //   }
        // })      
    },
    check_process_print(orders) {
      //還真的要檢查,但不是最後檢查寫log,而是...如果有部分商品設定有問題會造成部分票券其實信託失敗沒票號
      //此時就要回傳警告不要提示繼續列印以防呆
      for(let i = 0; i < orders.length; i++){
        // 檢查每筆訂單內各需要印出幾張紙
        // eslint-disable-next-line
        if (orders[i].order_status == 'accepted') {
          //有不是printed_to_deliver產票成功的訂單表示有問題
          return false
        }
      }
      return true
    },
    process(){
      console.log('1280',this.printway_selected)
      if (this.freightway_selected == null) {
        this.$bus.fnShowInfo("請先選擇處理的配送方式");
        return;
      }
      if (this.printway_selected == null) {
        this.$bus.fnShowInfo("請先選擇產票方式");
        return;
      }
      if(this.printway_selected == 0){
        //會直接產票的多confirm一下,減少誤按就產票下去的風險
        this.$bus.fnShowConfirm(('本操作耗時較久，且會針對待出貨紙本票訂單做信託取號，請問是否繼續?'),() => {
          this.process_api('print_preview');
          this.$bus.fnClosePopup()
          return
        }, () => {
          this.$bus.fnClosePopup()
          return 
        })
      }
      else {
        //剛執行查詢時都固定先回到第一頁,後續點下一頁/上一頁再做切換
        this.preview_page_number = 1
        this.page_cache = {}
        this.process_api('wait_order_selection')
        this.$bus.fnClosePopup()
      }
      /*if(this.printway_selected == 0){
        this.table_or_ticket = 'ticket';
        console.log(this.freightway_selected);
        let Param = {
          'module':'order',
          'method':'processPaperTicketOrder',
          'freight_way': this.freightway_selected,
          'pay_way':this.payway_selected,
          'pure_paper':this.paperway_selected,
          'return_preview_orders': this.printway_selected,
          'preview_page_number': 1,
          'preview_items_per_page': 1000,
          'order_ids': '',
          'force_reprint':1,
          'apiTarget':'ntsa',
        }
        let that = this;
        this.$bus.apiCall(Param, function(data) {
          if (data.ok === 0) {
            // console.log("失敗")
            that.ableToPrint = false;
            that.$bus.fnShowInfo(data.msg)
              // vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          else{
            alert("成功產票，列印前預覽");
            console.log(data)
            that.ableToPrint = true;
            that.orders = data.data
            for(let i = 0; i < that.orders.length; i++){
              // 檢查每筆訂單內各需要印出幾張紙
              console.log(`第${i}張訂單`,that.orders[i].papers);

              that.orders[i].papers.forEach(item => {
                // 再檢查每張紙是1張票或是2張票
                if(item.page_tickets.length == 2){
                  console.log("兩張");
                  // 一頁兩張票
                }if(item.page_tickets.length == 1){
                  console.log("一張");
                  // 一頁一張票
                }
                // else {
                //   alert("wrong data");
                //   that.empty = null;
                //   // 不是一張也不是兩張？？？
                // }
              })
            }
          }
        })
        // 沒有做catch
      } else if(this.printway_selected == 1){
        this.table_or_ticket = 'table';
        this.ableToPrint = false;
        // 同一個api 但先抓訂單列表
        // 選完再call 同一個api 產票
        console.log(this.freightway_selected);
        let Param = {
          'module':'order',
          'method':'processPaperTicketOrder',
          'freight_way': this.freightway_selected,
          'pay_way':this.payway_selected,
          'pure_paper':this.paperway_selected,
          'return_preview_orders': this.printway_selected,  // 回傳列表非票券
          'preview_page_number': 1,
          'preview_items_per_page': 1000,
          'order_ids': '',
          'force_reprint':1,
          'apiTarget':'ntsa',
        }
        let that = this;
        this.$bus.apiCall(Param, function(data) {
          if(data.ok === 0){
            //alert("抓訂單失敗")
            that.$bus.fnShowInfo(data.msg)
            return
          }
          alert("抓訂單成功");
          console.log(data.data);
          that.customized_orderlist = data.data;
        }) 
        // 沒有做catch       
      }
      else{
        console.log(this.printway_selected,"??");
        alert("something wrong");
        return
      }*/
    
    },
    closePopUp() {
      this.dialog = false
    },
    async openPopUp() {

      await apiGetQueueResultList().then((resp) => {
        console.log(resp)
        let data = resp.data.data 
        console.log(data)
        this.tableData = JSON.parse(JSON.stringify(data))
        this.dialog = true
      }).catch((error) => {
        console.log(error)
      })

    },
    satusText(item) {
      // console.log(item);
      switch (item.queueRes.st) {
        case 1:
          return '執行完畢，可查看結果'
        case 0:
          return '正在執行中'
        default:
          return '異常！！！！！'
      }
    },
    async getQueueResultListById(queueId) {

      await apiGetQueueResultListById(queueId).then((resp) => {
        console.log('1496行',resp)
        console.log('1497行',resp.data.data.queueRes.data)
        let arrs = resp.data.data.queueRes.data
        this.dialog = false
        this.table_or_ticket = 'ticket';
        if (this.check_process_print(arrs) === false) {
          this.$bus.fnShowInfo("產票結果含問題訂單(票券課程)，請用"+arrs[0].paper_batch_no+'查看狀態不是print_to_deliver的訂單，請業務確認訂單商品藍新是否正確上架，處理完成後再用此批號重新操作一次');  
          //不要繼續處理
          this.ableToPrint = false;
          return 
        }
        this.$bus.fnShowInfo("成功產票，列印前預覽 "+ queueId);
        // alert("成功產票，列印前預覽");
        //this.table_or_ticket = 'ticket';
        // eslint-disable-next-line
        
        this.ableToPrint = true;
        this.orders = resp.data.data.queueRes.data
        // 當下時間
        let now = new Date();
        let next_day = new Date();
        let next_next_day = new Date();
        // alert(now);
        this.now_year = now.getFullYear();
        this.now_month = now.getMonth() +1;  // 0 開始
        this.now_date = now.getDate();
        // 指定配送日隔天
        next_day.setDate(next_day.getDate()+1);

        this.next_day_year = next_day.getFullYear();
        this.next_day_month = next_day.getMonth() + 1;
        this.next_day_date = next_day.getDate();
        // 指定配送日隔兩天
        next_next_day.setDate(next_next_day.getDate()+2);

        this.next_next_day_year = next_next_day.getFullYear();
        this.next_next_day_month = next_next_day.getMonth() +1;
        this.next_next_day_date = next_next_day.getDate();


        //下面只是debug code而已
        for(let i = 0; i < this.orders.length; i++){
          // 檢查每筆訂單內各需要印出幾張紙
          // eslint-disable-next-line
          console.log(`第${i}張訂單`,this.orders[i].papers);

          this.orders[i].papers.forEach(item => {
            // 再檢查每張紙是1張票或是2張票
            if(item.page_tickets.length == 2){
              // eslint-disable-next-line
              console.log("兩張");
              // 一頁兩張票
            }if(item.page_tickets.length == 1){
              // eslint-disable-next-line
              console.log("一張");
              // 一頁一張票
            }
            // else {
            //   alert("wrong data");
            //   this.empty = null;
            //   // 不是一張也不是兩張？？？
            // }
          })
        }
  
      }).catch( (error) => {
        console.log(error)
      })

    }
  },
  created() {

    apiGetQueueResultList().then((resp) => {
      console.log('取得最新Queue結果',resp)
      let data = resp.data.data 
      //console.log(data)
      this.tableData = JSON.parse(JSON.stringify(data))
    }).catch((error) => {
      console.log(error)
    })
    
  },
  mounted() {
    this.isLoading = true;
    setTimeout(() => {
      this.isLoading = false
    }, 200);
    
    //不要自動撈全部,需要的自己下條件抓就好(無條件時查詢全部票券很耗資源,select total就需要近一秒)
    //this.searchTickets()
  }
}
</script>
<style scoped>
@import url(https://fonts.googleapis.com/earlyaccess/cwtexkai.css);
/* @import '../../assets/css/main.scss'; */
/* Add "scoped" attribute to limit CSS to this component only */
.paper {
  /* page-break-after: always;
  position: relative;
  display: block;
  height:29.7cm;
  width:21cm; */
  background: url(../../assets/images/background_paper.png);
  /* background-image: url('https://ibb.co/dBDVbrJ'); */
  background-size: cover;
}

.overlay-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  inline-size: 120vw;
  block-size: 120vh;
  backdrop-filter: blur(4px);
  pointer-events: inherit;
  background-color: rgba(4,15,21,.5);
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: center;
}

.overlay-background {
  position: absolute;
  display: block;
  width: 1200px;
  height: 50%;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
  overflow: auto;
  border-radius: 5px;
}

.Button {
  display: block;
  width: 150px;
  height: 40px;
  line-height: 40px;
  border: 0;
  background-color: rgb(245, 245, 150);
  color: rgba(0,0,0,0.7);
  font-size: 16px;
  margin-left: 25px;
  margin-top: 20px;
  margin-bottom: 20px;
  -webkit-appearance: none;
  border-radius: 5px;
  cursor: pointer;
}

.Button:hover {
  border: 1px solid rgb(245, 245, 180);
  color: rgb(245, 245, 180);
  background-color: rgba(0,0,0,0.5);
}

.order_export_download {
    text-align: center;
    display: block;
    height: 40px;
    width: 100%;
    line-height: 40px;
    color: #fff;
    /* animation:spin 4s linear infinite; */
}
.order_export_download:hover {
  /* transform: translateX(15px); */
  background-color: coral;
  transition: all .3s;
  cursor: pointer;
  text-decoration: none;
  
}


/*
.paper-inside {
  position: relative;
}

.ticket_no {
  position: absolute;
  -webkit-transform: rotate(270deg);
  -moz-transform: rotate(270deg);
  -o-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  transform: rotate(270deg);
  width:200px;
  height:80px;
  top:24em;
  left:2em;
}

.order_no {
  position: absolute;
  top:2em;
  left:20em;
}
.prod_name {
  position: absolute;
  top:4em;
  left:20em;
}
.qrcode {
  position: absolute;
  top:30em;
  right:8em;
}

.ticket_no2 {
  position: absolute;
  -webkit-transform: rotate(270deg);
  -moz-transform: rotate(270deg);
  -o-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  transform: rotate(270deg);
  width:200px;
  height:80px;
  top:58em;
  left:2em;
}

.order_no2 {
  position: absolute;
  top:36em;
  left:20em;
}
.prod_name2 {
  position: absolute;
  top:38em;
  left:20em;
}

.qrcode2 {
  position: absolute;
  top:64em;
  right:8em;
} */
</style>
